<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Manage Offices">
      <div class="text-right add-country" v-if="!officeAddEdit">
        <vs-button
          class="mt-4 mb-4 m-auto gradient-btn"
          @click.prevent="officeAddEdit = true"
        >Add Office</vs-button>
      </div>
      <form class="w-full" v-if="officeAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">{{ officeIndex ? 'Edit' : 'Add' }} Office</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Office Name"
              v-validate="'required|max:50'"
              name="office_name"
              v-model="office_name"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('office_name') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Address"
              v-validate="'required|max:100'"
              name="address"
              v-model="address"
            />
            <span class="text-danger text-sm">{{ errors.first('address') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full" v-show="hr_list.length != 0">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="''"
              label="HR/Manager"
              name="hr_id"
              v-model="hrID"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.firstname+' '+item.lastname"
                v-for="(item,index) in hr_list"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('hr_id') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Timezone"
              name="office_timezone"
              v-model="office_timezone"
            >
              <vs-select-item
                :key="index"
                :value="item.timezone"
                :text="item.display +' '+item.name"
                v-for="(item,index) in allTimezone"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('office_timezone') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="addUpdateOffice()"
              :disabled="button_loading"
              id="office-addupdate"
            >{{ officeIndex ? 'Save' : 'Add' }}</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddEdit()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5">
        <vs-table :data="offices" pagination max-items="15">
          <template slot="thead">
            <vs-th>Office Name</vs-th>
            <vs-th>Address</vs-th>
            <vs-th>HR/Manager</vs-th>
            <vs-th>Timezone</vs-th>
            <vs-th>QR Code</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.office_name }}</vs-td>
              <vs-td>{{ tr.address }}</vs-td>
              <vs-td>
                <span
                  v-if="tr.hr_manager"
                >{{ tr.hr_manager.firstname }} {{ tr.hr_manager.lastname }}</span>
                <span v-else>N/A</span>
              </vs-td>
              <vs-td>{{ tr.time_zone}}</vs-td>
              <vs-td>
                <img :src="tr.qr_code" class="code-border" alt @click="qrcodePrint(tr.qr_code,'O')" />
              </vs-td>
              <vs-td>
                <vs-button
                  color="#F4B400"
                  type="filled"
                  class="mr-2 mb-2 edit-user float-left"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit Office"
                  @click.stop="editOffice(data[indextr])"
                ></vs-button>
                <vs-button
                  color="#DB4437"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete Office"
                  @click.stop="confirmDelete(data[indextr].id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import timeZone from "@/mixins/timezone.js";

Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

//Validator.updateDictionary(dictionary);

const dict = {
  custom: {
    office_name: {
      required: "Please enter office name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Office name should not be greater than 50 characters"
    },
    address: {
      required: "Please enter office address",
      max: "Address should not be greater than 100 characters"
    },
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    hr_id: {
      required: "Please select HR-person"
    },
    office_timezone: {
      required: "Please select office timezone"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  data() {
    return {
      offices: [],
      deleteIndex: 0,
      officeAddEdit: false,
      officeIndex: null,
      office_name: null,
      office_timezone: null,
      address: null,
      hrID: null,
      hr_list: [],
      allTimezone: timeZone.data
    };
  },
  created() {
    if (
      this.$store.state.uInfo.role !== "CA" &&
      this.$store.state.uInfo.role !== "HR"
    ) {
      history.back();
    }
    //  VeeValidate.Validator.extend('verify_password', {
    //  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    //  validate: value => {
    //      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //      return strongRegex.test(value);
    //  }
    // });
  },
  mounted() {
    this.getHR();
    this.getOffice();
  },
  computed: {
    email_validate() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    }
  },
  methods: {
    getHR() {
      this.$vs.loading({ color: "primary" });

      let url = "user/getUsers?type=HR";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.hr_list = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.offices = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmDelete(index) {
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Office?",
        acceptText: "Delete",
        accept: this.deleteOffice
      });
    },
    deleteOffice() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("office/delete", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Office deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getOffice();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    editOffice(office) {
      this.officeAddEdit = true;
      this.officeIndex = office.id;
      this.office_name = office.office_name;
      this.address = office.address;
      if (office.hr_manager) {
        this.hrID = office.hr_manager.id;
      } else {
        this.hrID = null;
      }
      this.office_timezone = office.time_zone;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    addUpdateOffice() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#office-addupdate");

          if (this.officeIndex) {
            this.updateOffice();
          } else {
            this.addOffice();
          }
        }
      });
    },
    addOffice() {
      let input = {
        office_name: this.office_name,
        address: this.address,
        hr_manager: this.hrID,
        time_zone: this.office_timezone
      };
      this.axios
        .post("office/create", input)
        .then(response => {
          this.button_loader(false, "#office-addupdate");
          let text = "Office created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.officeAddEdit = false;
          this.office_name = null;
          this.address = null;
          this.hrID = null;
          this.officeIndex = null;
          this.office_timezone = null;
          this.getOffice();
        })
        .catch(e => {
          this.showError(e, "#office-addupdate");
        });
    },
    updateOffice() {
      let input = {
        id: this.officeIndex,
        office_name: this.office_name,
        address: this.address,
        hr_manager: this.hrID,
        time_zone: this.office_timezone
      };
      this.axios
        .put("office/edit", input)
        .then(response => {
          this.button_loader(false, "#country-addupdate");
          let text = "Office updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.officeAddEdit = false;
          this.office_name = null;
          this.address = null;
          this.hrID = null;
          this.officeIndex = null;
          this.office_timezone = null;
          this.getOffice();
        })
        .catch(e => {
          this.showError(e, "#country-addupdate");
        });
    },
    cancelAddEdit() {
      this.officeAddEdit = false;
      this.office_name = null;
      this.address = null;
      this.hrID = null;
      this.officeIndex = null;
      this.office_timezone = null;
    }
  }
};
</script>
<style>
.code-border {
  border: 1px solid;
}
</style>

		